export const de = {
  'sidebar.start': 'Start',
  'sidebar.setup': 'Setup',
  'sidebar.test01': 'Test01',
  'sidebar.test04': 'Test04',
  'sidebar.test05': 'Test05',
  'sidebar.test06': 'Test06',
  'sidebar.test07': 'Test07',
  'sidebar.live-chat': 'live-chat',

  'start': 'start',
  'appointments': 'termine',
  'documents': 'Dokumente',
  'advice': 'ratgeber und Tipps',

  'dashboard': 'Übersicht',
  'profile': 'profil',
  'contact': 'Kontakt',
  'logout': 'abmelden',
  'login': 'einloggen',
  'agenda': 'agenda',
  'single appointment': 'einzeltermin',
  'appointment chain': 'terminserie',

  'confirmed': 'bestätigt',
  'unconfirmed': 'unbestätigt',
  'canceled': 'abgesagt',
  'no-show': 'no-show',

  'control': 'kontrolle',
  'filling': 'kons',
  'surgery': 'chirurgie',
  'endo': 'endo',
  'prosthetics': 'prothetik',
  'ortho': 'kieferorthopädie',
  'exam': 'befund',
  'various': 'diverse',
  'prophylaxis': 'prophylaxe',

  'jan': 'Januar',
  'feb': 'Februar',
  'mar': 'März',
  'apr': 'April',
  'may': 'Mai',
  'jun': 'Juni',
  'jul': 'Juli',
  'aug': 'August',
  'sep': 'September',
  'oct': 'Oktober',
  'nov': 'November',
  'dec': 'Dezember',

  ':weg': 'ZA abwesend',
  ':room': 'Zimmer nicht frei',
  ':instr': 'Chirurgisches Instrumentarium bereits in Verwendung',
  ':scan': 'Scanner bereits in Verwendung',
  ':endo': 'Endo-Motor bereits in Verwendung',
  ':cnc': 'Fräsmaschine nicht frei',
  ':opt': 'OPT/DVT Gerät nicht frei',

  'passwords_do_not_match': 'Passwörter stimmen nicht überein',
  'user_already_registered': 'Benutzer bereits registriert. Bitte stattdessen anmelden.',
  'registration_failed': 'Registrierung fehlgeschlagen',
  'network_error': 'Netzwerkfehler',

  'swelling': 'Schwellung',
  'dental pain': 'Schmerz',
  'bleeding': 'Blutung',
  'broken tooth': 'Abgebrochenes Zahnstück',
  'lost filling': 'Herausgefallene Füllung',
  'lost crown or bridge': 'Herausgefallene Krone / Brücke',
  'problems after dental surgery': 'Beschwerden nach chirurgischem Eingriff',
  'sensitivity to hot or cold': 'Zahnschmerz nach warmem/kaltem Reiz',
  'braces or aligner emergency': 'Notfall bezüglich Zahnspange/Aligner',
  'left': 'links',
  'right': 'rechts',
  'upper': 'Oberkiefer',
  'lower': 'Unterkiefer',

  "control-DH-PA": "Zahnärztliche Kontrolle während Zahnreinigung",
  "control-general": "Kontrolltermin",
  "control-after-surgery": "Kontrolltermin nach chirurgischem Eingriff",
  "control-impl-impression": "Kontrolltermin nach Implantat",
  "control-periodontitis": "Kontrolltermin nach Parodontologie Behandlung",
  "control-prosthesis": "Kontrolltermin nach prothetischer Versorgung",
  "one-surface-filling": "Füllung",
  "two-surface-filling": "Füllung",
  "three-surface-filling": "Füllung",
  "extraction-8": "Weisheitszahnentfernung",
  "extraction": "Zahnentfernung",
  "extraction-and-impl": "Implantation",
  "impl": "Implantation",
  "paro-surgery": "Chirurgischer Eingriff",
  "try-in-cementation": "Termin für Einprobe der Zahnrekonstruktion",
  "reserve-cementation": "Termin für Zahnrekonstruktion",
  "pe-dressing": "Wurzelkanalbehandlung",
  "second-dressing": "Wurzelkanalbehandlung Termin 2",
  "root-canal-filling": "Wurzelkanalfüllung",
  "root-canal-filling-prep-impression-prov": "Wurzelkanalfüllung",
  "va": "Wurzelkanalbehandlung",
  "prep-impression-prov-single-tooth": "Termin für Zahnrekonstruktion",
  "prep-prov": "Termin für Zahnrekonstruktion",
  "prep-impression-60": "Termin für Präzisionsabformung",
  "impression-bite-shade": "Termin für Zahnprothese (allgemeine Abformung)",
  "impression-indiv": "Termin für Zahnprothese (individuelle Abformung)",
  "reg-wax-rim": "Termin für Zahnprothese (Registrierung)",
  "try-in-wax": "Termin für Zahnprothese (Einprobe)",
  "prep-impression-120": "Termin für Zahnprothese",
  "hand-over-prothesis": "Abgabe der Zahnprothese",
  "prep-impression-cement": "Termin für Zahnrekonstruktion",
  "prep-impression-prov-multi-tooth": "Termin für Zahnrekonstruktion",
  "impression": "Termin für Abformung",
  "hand-over-aligner": "Termin für Zahnstellungskorrektur",
  "impression-attachments-out": "Termin für Zahnstellungskorrektur",
  "retainer-in": "Retainer",
  "exam-aligner": "Befundtermin",
  "exam-new-patient": "Erstuntersuch",
  "exam-regular-patient": "Routinecheck",
  "exam-child": "Erstuntersuch für Kinder",
  "dental-cleaning-DH-60": "Zahnreinigung bei DH 60 min",
  "dental-cleaning-DH-120": "Zahnreinigung bei DH 120 min",
  "dental-cleaning-DH-90": "Zahnreinigung bei DH 90 min",
  "dental-cleaning-PA": "Zahnreinigung bei PA 60 min",
  "dental-cleaning-DH-by-dentist": "DH Zahnreinigung durch Zahnärzt:in",
  "dental-cleaning-PA-by-dentist": "PA Zahnreinigung durch Zahnärzt:in",
  "emergency": "Notfalltermin",
  "rx": "Röntgenaufnahme",
  "cons-aligner": "Besprechung Zahnstellung",
  "cons-bleaching": "Besprechung Zähne aufhellen",
  "cons-spint": "Besprechung Schiene",
  "cons-aesth": "Besprechung ästhetische Zahnmedizin",
  "cons-8": "Besprechung Weisheitszähne",
  "cons-impl": "Besprechung Implantat",
  "impression-mich": "Termin für Knirschschiene",
  "hand-over-mich": "Abgabe Knirschschiene",
  "second-opinion": "Zweitmeinung",

  "pro-control-DH-PA": "Kontrolle bei DH / PA",
  "pro-control-general": "Allg. Kontrolle",
  "pro-control-after-surgery": "Kontrolle nach Chirurgie",
  "pro-control-impl-impression": "Kontrolle Impl + Abformung",
  "pro-control-periodontitis": "Kontrolle Paro",
  "pro-control-prosthesis": "Kontrolle Prothetik",
  "pro-one-surface-filling": "Füllung 1fl",
  "pro-two-surface-filling": "Füllung 2fl",
  "pro-three-surface-filling": "Füllung 3fl",
  "pro-extraction-8": "OPEX 8er",
  "pro-extraction": "Ex",
  "pro-extraction-and-impl": "Ex, Implantation",
  "pro-impl": "Implantation",
  "pro-paro-surgery": "Parochirurgie",
  "pro-prep-surgery": "Vorbereitung Chirurgie",
  "pro-try-in-cementation": "Einprobe / Einsetzen",
  "pro-reserve-cementation": "Einsetzen Reservetermin",
  "pro-pe-dressing": "Aufbereitung, Einlage",
  "pro-second-dressing": "Einlage II",
  "pro-root-canal-filling": "Wurzelfüllung",
  "pro-root-canal-filling-prep-impression-prov": "Wurzelfüllung, Präp, Abformung, Provi",
  "pro-va": "VA",
  "pro-prep-impression-prov-single-tooth": "Präp, Abformung, Provi Einzelzahn",
  "pro-prep-prov": "Präp, Provi",
  "pro-prep-impression-60": "Präp, Abformung 60 min",
  "pro-impression-bite-shade": "Abformung, Bissnahme, Farbwahl",
  "pro-impression-indiv": "Abformung mit individuellem Löffel",
  "pro-reg-wax-rim": "Registrat mit Wachswall",
  "pro-try-in-wax": "Einprobe in Wachs",
  "pro-prep-impression-120": "Präp, Abformung 120 min",
  "pro-hand-over-prothesis": "Abgabe",
  "pro-prep-impression-cement": "Präp, Abformung, Einsetzen",
  "pro-prep-impression-prov-multi-tooth": "Präp, Abformung, Provi mehrere Zähne",
  "pro-impression": "Abformung",
  "pro-hand-over-aligner": "Übergabe Aligner",
  "pro-impression-attachments-out": "Abformung, Attachments entfernen",
  "pro-retainer-in": "Retainer kleben",
  "pro-exam-aligner": "Befund Aligner",
  "pro-exam-new-patient": "Befund Neupatient",
  "pro-exam-regular-patient": "Routinecheck bei Zaz",
  "pro-exam-child": "Befund Kind",
  "pro-dental-cleaning-DH-120": "Zahnreinigung DH 120 min",
  "pro-dental-cleaning-DH-90": "Zahnreinigung DH 90 min",
  "pro-dental-cleaning-DH-60": "Zahnreinigung DH 60 min",
  "pro-dental-cleaning-PA": "Zahnreinigung PA",
  "pro-dental-cleaning-DH-by-dentist": "Zahnreinigung DH durch Zaz",
  "pro-dental-cleaning-PA-by-dentist": "Zahnreinigung PA durch Zaz",
  "pro-emergency": "Notfall",
  "pro-rx": "Röntgenaufnahme",
  "pro-reserve": "Reserve",
  "pro-cons-aligner": "Besprechung Aligner",
  "pro-cons-bleaching": "Besprechung Bleaching",
  "pro-cons-spint": "Besprechung Schiene",
  "pro-cons-aesth": "Besprechung ästhetische Zahnmedizin",
  "pro-cons-8": "Besprechung 8er",
  "pro-cons-impl": "Besprechung Implantat",
  "pro-emergency-call": "Notfalldienst",
  "pro-holiday": "Ferien",
  "pro-day-off": "Ferientag",
  "pro-further-education": "Weiterbildung",
  "pro-sick": "krank",
  "pro-birthday": "Geburtstag",
  "pro-meeting": "Sitzung",
  "pro-last-min-cancellation": "kurzfristige Absage",
  "pro-no-show": "Termin verpasst / nicht erschienen",
  "pro-observation-day": "Schnuppertag",
  "pro-anesthesia-treatment": "Narkose Behandlung",
  "pro-admission-anesthesia": "Eintritt für Narkose",
  "pro-impression-mich": "Abformung Mich",
  "pro-hand-over-mich": "Abgabe Mich",
  "pro-various": "Diverses",

  "description-dental-cleaning-DH-60": "Professionelle Zahneinigung für eine optimale Mundhygiene und Vorsorge",
  "description-emergency": "Zahnschmerzen, Zahn abgebrochen, Füllung locker, Krone herausgefallen",
  "description-exam-regular-patient": "Allgemeine Kontrolle, Beurteilung von Schleimhautveränderungen, Verfärbungen und Vorsorge",
  "description-cons-8": "Begutachung und Planung der Entfernung von Weisheitszähnen",
  "description-cons-aligner": "Beratung zu Aligner-Therapien und Möglichkeiten der Zahnstellungskorrektur",
  "description-cons-bleaching": "Beratung zum Bleaching der Zähne für ein natürlich weisses Lächeln",
  "description-cons-spint": "Beratung zu Knirschschienen, Schnarchschienen oder Sportschienen",
  "description-cons-impl": "Beratung zu feststitzendem Zahnersatz und modernen Implantatlösungen",
  "description-cons-aesth": "Individuelle Beratung zu Veneers, Kronen und ästhetischen Korrekturen",
  "description-second-opinion": "Unabhängige Beratung eines bereits bestehenden Behandlungsplans",

  "description-exam-new-patient": "Erstbefundaufnahme inkl. allgemeiner Kontrolle, Beurteilung von Schleimhautveränderungen und Vorsorge - Bei Bedarf Terminvergabe zur Zahnreinigung",
  "description-exam-child": "Kontrolle für die Kleinen und umfassende Kariesprävention.",

  "messagePleaseCall": "Rufen Sie uns gerne direkt an unter ",
  "messageNewPatient": "Bitte beachten Sie: Der erste Termin bei Neupatienten erfolgt immer zuerst bei einer Zahnärztin oder einem Zahnarzt, um unseren Qualitätsstandard zu sichern. Termine für die Zahnreinigung vergeben wir erst danach.",

  "no-appointments-available": "Keine Termine",
  "chain-date-range-short-hover": "Der ausgewählte Termin ist Teil einer Terminserie und muss zwischen dem {from} und {to} stattfinden.",
  "chain-hover-text": "Termin-Serie",
  "no-chain-cancellation": "Dieser Termin ist Teil einer Terminserie und kann online nicht abgesagt werden. Bitte melden sie sich telefonisch in der Praxis: 052 625 46 25.",
};
